import { render, staticRenderFns } from "./dealerlogin.vue?vue&type=template&id=7568ab3a&scoped=true&"
import script from "./dealerlogin.vue?vue&type=script&lang=js&"
export * from "./dealerlogin.vue?vue&type=script&lang=js&"
import style0 from "./dealerlogin.vue?vue&type=style&index=0&id=7568ab3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7568ab3a",
  null
  
)

export default component.exports